<p [class.collapsed]="isCollapsed" [class.loading]="isLoading" [style.height]="isCollapsed ? maxHeight + 'px' : 'auto'">
    {{ text }}
    <a *ngIf="isCollapsible" (click)="isCollapsed = !isCollapsed">{{ isCollapsed ? 'more' : 'less' }}</a>
</p>
